export default "__VITE_ASSET__CJYQuvAJ__"